/* kl-search v1.1 (2026-09-10) — 站内搜索「所见即所得」层。老板:「搜名字下面不显示该产品…深度优化每一个网站的搜索」。
   根因:Shopify 原生搜索对多词查询是 OR + 模糊匹配,再按它自己的相关性排序;整名「Ridgeline Alabaster Linear Chandelier」
   会被一堆只命中 alabaster/chandelier 标签的商品挤掉。Shopify 支持前缀语法(term*)且每个词都带 * 时变成 AND。
   做法:① 拦截主题/自建搜索框对 /search/suggest(.json) 的请求,把 q 改写成「每词加 *」的 AND 查询;空结果自动回退原查询;
        ② 搜索表单提交前用 1 条 suggest 探测,同样 AND 优先、空则原样;③ 结果页把可见的 * 去掉。不改任何主题文件的搜索代码。 */
(function () {
  'use strict';
  if (window.__klSearch) return; window.__klSearch = { v: '1.1' };
  var STOP = /[*"':()\[\]{}]/;                                  // 用户自己用了语法就不动
  var ASCII = /^[\x20-\x7EÀ-ɏ]+$/;                     // 拉丁文字才改写(日/阿等分词不同,保持原样)
  function stem(t) {
    var w = t.replace(/[^\w\-]+$/, '');
    if (w.length > 3 && /s$/i.test(w) && !/ss$/i.test(w)) w = /(ches|shes|xes|zes)$/i.test(w) ? w.slice(0, -2) : w.slice(0, -1);
    return w;
  }
  function tier1(q) {
    q = (q || '').trim();
    if (!q || STOP.test(q) || !ASCII.test(q)) return null;
    var terms = q.split(/\s+/).filter(Boolean); if (!terms.length) return null;
    var out = terms.map(function (t) { var s = stem(t); return /[A-Za-z0-9À-ɏ]$/.test(s) ? s + '*' : t; }).join(' ');
    return out === q ? null : out;
  }
  function isSuggest(u) { try { var p = new URL(u, location.origin); return p.origin === location.origin && /\/search\/suggest(\.json)?\/?$/.test(p.pathname) && p.searchParams.has('q'); } catch (e) { return false; } }
  function skuOnly(p) { var f = p.searchParams.get('resources[options][fields]') || ''; return f && !/title/.test(f); }
  function hasHits(text, json) {
    if (json) { try { var r = (JSON.parse(text).resources || {}).results || {}; return Object.keys(r).some(function (k) { return Array.isArray(r[k]) && r[k].length > 0; }); } catch (e) { return true; } }
    return /\/products\/|\/collections\/[a-z0-9-]+"|\/blogs\//.test(text);
  }
  function scrub(text, star, raw) {  // 只把响应里「可见文本」回显的带 * 查询换回用户输入;链接里的编码形式保留(结果页仍走 AND)
    if (!star || star === raw) return text;
    return text.split(star).join(raw);
  }
  /* ── fetch ── */
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (!url || !isSuggest(url)) return _fetch.apply(this, arguments);
      var u = new URL(url, location.origin), raw = u.searchParams.get('q'), star = tier1(raw);
      if (!star || skuOnly(u)) return _fetch.apply(this, arguments);
      var u1 = new URL(u.toString()); u1.searchParams.set('q', star); var json = /\.json\/?$/.test(u.pathname), self = this, args = arguments;
      return _fetch.call(self, u1.toString(), init).then(function (res) {
        if (!res.ok) return _fetch.apply(self, args);
        return res.clone().text().then(function (text) {
          if (!hasHits(text, json)) return _fetch.apply(self, args);
          var h = new Headers(res.headers); h.delete('content-length');
          return new Response(scrub(text, star, raw), { status: res.status, statusText: res.statusText, headers: h });
        });
      }).catch(function () { return _fetch.apply(self, args); });
    };
  }
  /* ── XMLHttpRequest(老主题):只改写,不回退 ── */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && isSuggest(url)) {
          var u = new URL(url, location.origin), raw = u.searchParams.get('q'), star = tier1(raw);
          if (star && !skuOnly(u)) { u.searchParams.set('q', star); arguments[1] = u.toString(); }
        }
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  }
  /* ── 搜索表单提交:AND 优先,探测为空则原样 ── */
  var cfg = document.getElementById('kl-search-config'); var searchUrl = '/search';
  try { searchUrl = (JSON.parse(cfg.textContent).search_url || '/search').replace(/\/$/, ''); } catch (e) {}
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!(f instanceof HTMLFormElement)) return;
    var action = (f.getAttribute('action') || '').split('?')[0].replace(/\/$/, '');
    if (!/\/search$/.test(action)) return;
    var inp = f.querySelector('input[name="q"]'); if (!inp) return;
    var raw = inp.value.trim(), star = tier1(raw); if (!star) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var params = new URLSearchParams(new FormData(f)); params.set('q', star); if (!params.has('type')) params.set('type', 'product');
    var go = function (useStar) { if (!useStar) params.set('q', raw); location.assign(action + '?' + params.toString()); };
    var probe = action + '/suggest.json?' + new URLSearchParams({ q: star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    var done = false, t = setTimeout(function () { if (!done) { done = true; go(false); } }, 1500);
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true; clearTimeout(t);
      var ps = (((j || {}).resources || {}).results || {}).products || []; go(ps.length > 0);
    }).catch(function () { if (!done) { done = true; clearTimeout(t); go(false); } });
  }, true);
  /* ── 自建搜索框的「查看全部结果」/联想词链接:同样 AND 优先 ── */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null; if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    var u; try { u = new URL(a.getAttribute('href'), location.origin); } catch (err) { return; }
    if (u.origin !== location.origin || !/\/search\/?$/.test(u.pathname) || !u.searchParams.has('q')) return;
    var raw = u.searchParams.get('q'), star = tier1(raw); if (!star) return;
    e.preventDefault();
    var probe = u.pathname.replace(/\/$/, '') + '/suggest.json?' + new URLSearchParams({ q: star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    var done = false, t = setTimeout(function () { if (!done) { done = true; location.assign(u.toString()); } }, 1500);
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      if (done) return; done = true; clearTimeout(t);
      var ps = (((j || {}).resources || {}).results || {}).products || []; if (ps.length) u.searchParams.set('q', star); location.assign(u.toString());
    }).catch(function () { if (!done) { done = true; clearTimeout(t); location.assign(u.toString()); } });
  }, true);
  /* ── 结果页:原样查询(回车/外链进来)先探测 AND 有结果就换成 AND;带 * 的把可见 * 去掉 ── */
  function upgrade(q) {
    var star = tier1(q); if (!star) return;
    var u = new URL(location.href); var probe = u.pathname.replace(/\/$/, '') + '/suggest.json?' + new URLSearchParams({ q: star, 'resources[type]': 'product', 'resources[limit]': '1' }).toString();
    _fetch(probe).then(function (r) { return r.json(); }).then(function (j) {
      var ps = (((j || {}).resources || {}).results || {}).products || [];
      if (ps.length) { u.searchParams.set('q', star); location.replace(u.toString()); }
    }).catch(function () {});
  }
  function clean() {
    var q; try { q = new URL(location.href).searchParams.get('q'); } catch (e) { return; }
    if (!q) return;
    if (q.indexOf('*') < 0) { upgrade(q); return; }
    var raw = q.replace(/\*/g, '');
    var inputs = document.querySelectorAll('input[name="q"], input[type="search"]');
    Array.prototype.forEach.call(inputs, function (i) { if (i.value === q) i.value = raw; });
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf(q) > -1) list.push(n); }
    list.forEach(function (n) { n.nodeValue = n.nodeValue.split(q).join(raw); });
    try { if (document.title.indexOf(q) > -1) document.title = document.title.split(q).join(raw); } catch (e) {}
  }
  if (/\/search\/?$/.test(location.pathname)) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean); else clean(); }
  window.__klSearch.tier1 = tier1;
})();
